import React from 'react';
import P from '@hero/ui-kit/typography/P';
import Tag from '@hero/ui-kit/components/Tag';
import type { SegmentUsage } from '../../types';

type Props = {
    usedBy: SegmentUsage;
};

const UsageRow: React.FC<{
    entry: SegmentUsage['drips'][number] | SegmentUsage['blasts'][number];
}> = ({ entry }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0.6rem 0',
            borderBottom: '1px solid #eee'
        }}
    >
        <P noDefaultMargin>{entry.name}</P>
        <Tag type={entry.usage === 'enrollment' ? 'primary' : 'warn'} size="small">
            {entry.usage === 'enrollment' ? 'Enrollment' : 'Check segment'}
        </Tag>
    </div>
);
const SegmentUsedByList: React.FC<Props> = ({ usedBy }) => {
    if (!usedBy || !Array.isArray(usedBy.drips) || !Array.isArray(usedBy.blasts)) {
        return <P noDefaultMargin>Usage information is unavailable for this segment.</P>;
    }
    const totalUsages = usedBy.drips.length + usedBy.blasts.length;
    if (totalUsages === 0) {
        return (
            <P
                styles={{
                    padding: '2rem 0',
                    textAlign: 'center',
                    color: 'var(--mark-muted)'
                }}
            >
                Not used by any drips or blasts.
            </P>
        );
    }
    return (
        <div>
            {usedBy.drips.length > 0 && (
                <div
                    style={{
                        marginBottom: '1.6rem'
                    }}
                >
                    <P
                        noDefaultMargin
                        strong
                        styles={{
                            marginBottom: '0.8rem'
                        }}
                    >
                        Drips ({usedBy.drips.length})
                    </P>
                    {usedBy.drips.map((entry) => (
                        <UsageRow key={`${entry.drip_id}:${entry.usage}`} entry={entry} />
                    ))}
                </div>
            )}
            {usedBy.blasts.length > 0 && (
                <div>
                    <P
                        noDefaultMargin
                        strong
                        styles={{
                            marginBottom: '0.8rem'
                        }}
                    >
                        Blasts ({usedBy.blasts.length})
                    </P>
                    {usedBy.blasts.map((entry) => (
                        <UsageRow key={`${entry.blast_id}:${entry.usage}`} entry={entry} />
                    ))}
                </div>
            )}
        </div>
    );
};
export default SegmentUsedByList;
